<template>
  <div class="page_modal">
    <filter-modal />
    <login-modal />
    <qrcode-modal />
    <change-order />
    <cancel-order />
    <calendar-modal />
  </div>
</template>

<script>
import FilterModal from '@/components/modal/FilterModal';
import LoginModal from '@/components/modal/LoginModal';
import QrcodeModal from '@/components/modal/QrcodeModal';
import ChangeOrder from '@/components/modal/ChangeOrder';
import CancelOrder from '@/components/modal/CancelOrder';
import CalendarModal from '@/components/modal/CalendarModal';

export default {
  components: {
    // 您的樣板
    FilterModal: FilterModal,
    LoginModal: LoginModal,
    QrcodeModal,
    ChangeOrder,
    CancelOrder,
    CalendarModal,
  },
};
</script>
